import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { AdminSidebar } from './AdminSidebar';
import { Loader2 } from 'lucide-react';

/**
 * Layout for the admin section (/admin/*).
 * Only accessible to platform admins.
 * Has its own sidebar separate from the clinic layout.
 */
export function AdminLayout() {
  const { isPlatformAdmin, status } = useAuth();

  if (status === 'initializing') {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-900">
        <Loader2 className="h-8 w-8 animate-spin text-amber-500" />
      </div>
    );
  }

  if (!isPlatformAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="flex h-screen min-h-0 flex-col">
      <div className="flex min-h-0 flex-1">
        <AdminSidebar />
        <main className="flex min-w-0 flex-1 flex-col overflow-hidden bg-gray-50 dark:bg-gray-900">
          <div className="flex-1 overflow-y-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
